module.exports = __webpack_public_path__ + "img/dsci0032.eec98a2f.jpg";